var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVklogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12_222)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.605 0H10.395C1.99 0 0 1.99 0 10.395V19.605C0 28.01 1.99 30 10.395 30H19.605C28.01 30 30 28.01 30 19.605V10.395C30 1.99 27.9888 0 19.605 0ZM24.22 21.4037H22.04C21.215 21.4037 20.96 20.7475 19.4775 19.245C18.1862 17.995 17.615 17.8263 17.2975 17.8263C16.8525 17.8263 16.725 17.9538 16.725 18.5675V20.5363C16.725 21.0663 16.5562 21.3838 15.1587 21.3838C12.8512 21.3838 10.2887 19.9862 8.49 17.3813C5.78 13.5712 5.0375 10.7125 5.0375 10.12C5.0375 9.8025 5.165 9.50625 5.77875 9.50625H7.95875C8.50875 9.50625 8.72125 9.76 8.93375 10.3525C10.0125 13.465 11.8125 16.1962 12.5538 16.1962C12.8288 16.1962 12.9562 16.0688 12.9562 15.3713V12.1512C12.8713 10.6687 12.0875 10.5425 12.0875 10.0138C12.0875 9.75875 12.3 9.505 12.6375 9.505H16.0675C16.5338 9.505 16.7025 9.75875 16.7025 10.3088V14.65C16.7025 15.115 16.915 15.285 17.0413 15.285C17.3162 15.285 17.55 15.115 18.0575 14.6075C19.625 12.85 20.7463 10.14 20.7463 10.14C20.895 9.8225 21.1488 9.52625 21.7 9.52625H23.88C24.5362 9.52625 24.685 9.86375 24.5362 10.33C24.2612 11.6012 21.5938 15.3687 21.5938 15.3687C21.3612 15.75 21.2762 15.9187 21.5938 16.3438C21.8263 16.6612 22.5888 17.3175 23.0975 17.91C24.0288 18.9688 24.7475 19.8575 24.9388 20.4725C25.1513 21.085 24.8325 21.4025 24.2188 21.4025L24.22 21.4037Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12_222"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVklogo);
export default __webpack_public_path__ + "static/media/vk logo.616410a97101ac0dfd412e73daa02eec.svg";
export { ForwardRef as ReactComponent };